import { Badge, Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/FranciscoGiancarelli.jpeg";

const FranciscoGiancarelli: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      <div className='d-flex flex-row align-items-center mb-2'>
        <img
          className='rounded-circle mr-2'
          width={92}
          alt='Foto de perfil de Francisco Giancarelli'
          height={92}
          src={ProfilePicture}
        />
        <div>
          <h1>Francisco Giancarelli</h1>
          <h3 className='text-muted'>Mobile team</h3>
        </div>
      </div>
      <p>
        Hola, soy Francisco Giancarelli, parte del equipo de desarrollo de
        aplicaciones móviles. En la empresa me dedico a desarrollar en
        react-native. Pero de vez en cuando toco algún proyecto de react cuando
        se necesita.
      </p>
      <p>
        Soy estudiante de Ingeniería en Sistemas de Información en la UTN FRSF,
        me gusta escuchar Arjona y Justin Bieber mientras trabajo, y me encanta
        la programación 🤓.
      </p>
      <p>
        Algunas de las tecnologías que manejo son{" "}
        <Badge className='mr-1' variant='primary'>
          react
        </Badge>
        <Badge className='mr-1' variant='info'>
          react-native
        </Badge>
        <Badge className='mr-1' variant='warning'>
          graphql
        </Badge>
        <Badge className='mr-1' variant='danger'>
          firebase
        </Badge>
      </p>
    </Container>
  );
};

export default new Content({
  Component: FranciscoGiancarelli,
  title: "Francisco Giancarelli",
  route: "francisco-giancarelli",
  tags: [
    "senior",
    "mobile",
    "front",
    "front-end",
    "node",
    "nodejs",
    "react",
    "react-native",
    "android",
    "ios",
    "test",
    "test-flight",
    "npm",
    "jest",
    "firebase",
    "appstoreconnect",
    "appstore",
    "playstore",
    "java",
    "swift",
    "objective",
    "objective-c",
    "native",
    "modules",
    "nativemodules",
    "native-modules",
    "native modules",
    "bluetooth"
  ]
});
